import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import SidebarCustomSection from "../common/custom-sections";
export default class SidebarAnonymousCustomSections extends SidebarCustomSection {
  constructor() {
    super(...arguments);
    _defineProperty(this, "anonymous", true);
  }
}